import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MustMatch } from 'src/app/helpers/must-match.validator';

@Component({
  selector: 'app-register-email',
  templateUrl: './register-email.page.html',
  styleUrls: ['./register-email.page.scss'],
})
export class RegisterEmailPage implements OnInit {

  emailForm: FormGroup

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.initConstructor();
  }

  private initConstructor() {
    this.emailForm = this.formBuilder.group({
      email: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
        ]),
      ],
      confirmEmail: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
        ]),
      ],
      password: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.,'_~]).{8,}$")
        ]),
      ],
      confirmPassword: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.,'_~]).{8,}$")
        ]),
      ]
    }, {
      validator: MustMatch('password', 'confirmPassword')
    });
  }

  get f() { return this.emailForm.controls; }

  seePassword(input, icon){
    input.type = input.type == 'text' ? 'password': 'text';
    icon.name = icon.name == 'eye-outline' ? 'eye-off-outline' : 'eye-outline';
  }

}
